import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=7dc157f6&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=7dc157f6&prod&lang=scss&scoped=true&"
import style1 from "./Terms.vue?vue&type=style&index=1&id=7dc157f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc157f6",
  null
  
)

export default component.exports